<template>
  <div class="pages-description">
    <div class="description-card">
      <Icon name="material-symbols:info" class="info-icon" />
      <div class="description-content">
        <p class="description-text">{{ $t('pay.pagesDesc.description') }}</p>
      </div>
    </div>

    <div class="rules-section">
      <h4 class="rules-title">{{ $t('pay.pagesDesc.title') }}</h4>
      <ul class="rules-list">
        <li class="rule-item">
          <Icon name="material-symbols:check-circle" class="rule-icon" />
          <span>{{ $t('pay.pagesDesc.rules.0') }}</span>
        </li>
        <li class="rule-item">
          <Icon name="material-symbols:check-circle" class="rule-icon" />
          <span>{{ $t('pay.pagesDesc.rules.1') }}</span>
        </li>
        <li class="rule-item">
          <Icon name="material-symbols:check-circle" class="rule-icon" />
          <span>{{ $t('pay.pagesDesc.rules.2') }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
.pages-description {
  margin-bottom: 32px;
}

.description-card {
  display: flex;
  gap: 16px;
  padding: 20px;
  background: #e7f3ff;
  border-radius: 12px;
  border: 1px solid #b3d9ff;
  margin-bottom: 20px;

  .info-icon {
    font-size: 24px;
    color: #4A90E2;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .description-content {
    flex: 1;
  }

  .description-text {
    font-size: 14px;
    color: #212529;
    line-height: 1.6;
    margin: 0;
  }
}

.rules-section {
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;

  .rules-title {
    font-size: 16px;
    font-weight: 600;
    color: #212529;
    margin: 0 0 12px 0;
  }

  .rules-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .rule-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 0;
    font-size: 14px;
    color: #495057;
    line-height: 1.5;

    &:not(:last-child) {
      border-bottom: 1px solid #e9ecef;
    }

    .rule-icon {
      font-size: 18px;
      color: #50E3C2;
      flex-shrink: 0;
      margin-top: 2px;
    }
  }
}

@media (max-width: 768px) {
  .description-card {
    padding: 16px;
  }

  .rules-section {
    padding: 16px;
  }
}
</style>
